import React, { useEffect, useState } from "react";
import AuthHeader from "../components/Headers/AuthHeader.component";
import Footer1 from "../components/Footers/Footer1.component";
import { Link } from "react-router-dom"; 
import { useSelector } from "react-redux";

// components
import Loader from "../components/Loader.component";
import ReactImageFallback from "react-image-fallback";


// images
import defaultUser from "../assets/images/default_profile_pic.jpg";
import SingleNotification from "../components/SingleNotification.component";

export default function Notifications() {
  // Redux State
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.auth.data);

  // Local State
  const [notifications, setNotifications] = useState("");
  
  useEffect(() => {
    const interval = setInterval(() => {
      // console.log('New Notification Call');
      getAllNotifications();
    }, 10000);

    return () => clearInterval(interval);
  }, [notifications]);
  

  useEffect(() => {
    getAllNotifications();
  }, []);

  const getAllNotifications = async () => {
    // ${process.env.REACT_APP_BASE_URL}/api/notifications?user_id=${userData.id}{
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/notifications?user_id=${userData.id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.success) {
          setNotifications(response.records);
        } else {
          console.log(response);
        }
      });
  };


  return (
    <>
      <AuthHeader />

      <section className="bds-main-section bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-xl-8">
              <div className="bds-sectiontitle">
                <div className="bds-featureRating">
                  <h3 className="mb-3">All Notifications</h3>
                </div>

                {!notifications ? (
                  <Loader />
                ) : notifications?.data.length > 0 ? (
                  notifications.data.map((item, idx) => (
                    <SingleNotification
                      item={item}
                      key={idx}
                    />
                  ))
                ) : (
                  <div className="text-center my-5 text-muted">
                    No Notification Found
                  </div>
                )}                
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer1 />
    </>
  );
}
